import script from "./FilePreview_gallery.vue?vue&type=script&lang=js"
export * from "./FilePreview_gallery.vue?vue&type=script&lang=js"

import "./FilePreview_gallery.vue?vue&type=style&index=0&id=483e8f40&lang=scss"

const __exports__ = script;

export default __exports__